import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "_mt-a"
}
const _hoisted_2 = {
  key: 0,
  class: "_flex _ai-b _flexwrap"
}
const _hoisted_3 = {
  key: 0,
  class: "gfu-bt gfu-bt--caption _tc--lighter",
  "data-qa": "project-card:FundedAtText"
}
const _hoisted_4 = {
  key: 1,
  class: "gfu-bt gfu-bt--caption _tc--lighter"
}
const _hoisted_5 = {
  key: 1,
  class: "_flex _flexwrap _ai-b"
}
const _hoisted_6 = { class: "gfu-bt gfu-bt--caption _tc--lighter" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (!$options.isProjectV1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($options.showCrowdfundingOnlyFundsGathered)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(['gfu-hd gfu-hd--h3 _mr-1', {'_tc--inverse': $props.scheme === 'inverse'}]),
                "data-qa": "project-card:FundsGathered"
              }, _toDisplayString(_ctx.$format($props.fundsGathered, 'C0', $props.currencySymbol)), 3 /* TEXT, CLASS */),
              ($props.showFundedAt && $options.fundedAtText)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_ctx.Resources.format(_ctx.Resources.Homepage.ProjectCardFundingGoalReachedInCaption, $options.fundedAtText)) + " ", 1 /* TEXT */),
                    _createVNode(_component_tooltip, null, {
                      content: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.format(_ctx.Resources.Homepage.ProjectCardFundingGoalPercentageTooltip, $props.fundsGatheredPercentage)), 1 /* TEXT */)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_base_icon, { name: "circle-info" })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.Resources.Homepage.ProjectCardFundingAmountPledgedCaption), 1 /* TEXT */))
            ]))
          : ($options.showEverythingFundsGathered)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(['gfu-hd gfu-hd--h3 _mr-1', {'_tc--inverse': $props.scheme === 'inverse'}]),
                  "data-qa": "project-card:FundsGathered"
                }, _toDisplayString(_ctx.$format($props.fundsGathered, 'C0', $props.currencySymbol)), 3 /* TEXT, CLASS */),
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Homepage.ProjectCardFundingTotalCaption) + " ", 1 /* TEXT */),
                  _createVNode(_component_tooltip, null, {
                    content: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.Homepage.ProjectCardFundingTotalTooltip), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_base_icon, { name: "circle-info" })
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]))
            : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}